
import { defineComponent } from 'vue';
import DataMixins from "@/mixins/DataMixins";
import WelcomeCardsMixins from "@/data/WelcomeCardsMixins";

export default defineComponent({
  name: "WelcomeCardsComponent",
  mixins: [DataMixins, WelcomeCardsMixins]
})
